import React from 'react';
import { Box, Step, StepLabel, Stepper } from '@mui/material';

const maxWidth = '35rem';

interface CircleProps {
  isActiveStep: boolean,
}

const StepCircle: React.FC<CircleProps> = ({ isActiveStep }: CircleProps) => (
  <Box
    sx={(t) => ({
      backgroundColor: isActiveStep ? 'white' : t.palette.grey2,
      border: `1px solid ${isActiveStep ? t.palette.primary1 : t.palette.grey3}`,
      borderRadius: '50%',
      boxShadow: isActiveStep ? '0 2px 8px rgb(255 104 0 / 40%)' : 'none',
      height: '22px',
      width: '22px',
    })}
  />
);

interface Props {
  activeStep: string,
  className?: string,
  disabledSteps?: Array<string>,
  onStepClick?: (index: number) => void;
  steps: { [key: string]: { label: string } };
}

const StepTracker: React.FC<Props> = ({
  activeStep,
  className,
  disabledSteps = [],
  onStepClick,
  steps,
}: Props) => {
  const stepNames = Object.keys(steps);
  const currentIndex: number = stepNames
    .filter((step: string) => !disabledSteps.includes(step))
    .indexOf(activeStep);

  return (
    <Stepper
      activeStep={currentIndex}
      alternativeLabel
      className={className}
      sx={{ maxWidth, padding: 0 }}
    >
      {stepNames
        .filter((step) => !disabledSteps.includes(step))
        .map((step, i) => (
          <Step
            key={steps[step].label}
            classes={{ root: i < currentIndex && onStepClick ? 'stepPriorToCurrent' : '' }}
            onClick={onStepClick ? () => onStepClick(i) : undefined}
          >
            <StepLabel
              StepIconComponent={
                i >= currentIndex && !onStepClick
                  ? () => <StepCircle isActiveStep={i === currentIndex} />
                  : undefined
              }
            >
              {steps[step].label}
            </StepLabel>
          </Step>
        ))}
    </Stepper>
  );
};

export default StepTracker;
